import { useState } from 'react';
import { STORAGE_KEYS } from '../constants';
import { saveQuizData } from './useLocalStorage';

export const useQuiz = () => {
  const [page, setPage] = useState('login');
  const [currentQuestionNum, setCurrentQuestionNum] = useState(1);
  const [questionLength, setQuestionLength] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isCorrect, setIsCorrect] = useState(false);
  const [wrongQuestions, setWrongQuestions] = useState([]);

  const handleStartQuiz = async (value) => {
    try {
      const fileNameMap = {
        'SalesforceCertifiedAdministrator': 'administratorQuestions',
        'SalesforcePlatformAppBuilder': 'platformappbuilderQuestions',
        'SalesforcePlatformDeveloperI': 'platformdeveloper1Questions',
        'SalesforceSalesCloud': 'salescloudQuestions',
        'Service Cloudコンサルタント': 'servicecloudQuestions',
        'Experience Cloudコンサルタント JPN': 'experiencecloudQuestions',
        '上級アドミニストレーター JPN': 'advancedadministratorQuestions',
        'DataCloudコンサルタント JPN': 'datacloudQuestions',
        'FieldServiceコンサルタント JPN': 'FieldServiceQuestions'
      };

      const fileName = fileNameMap[value];
      if (!fileName) {
        throw new Error('Invalid quiz type');
      }

      const response = await fetch(`${process.env.PUBLIC_URL}/data/${fileName}.json`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      const randomNum = Math.round(Math.random() * (data.length - 1));

      setQuestionLength(data.length);
      setQuestions(data);
      setCurrentQuestionIndex(randomNum);
      setCurrentQuestionNum(1);
      setWrongQuestions([]);
      
      saveQuizData(data, randomNum, data.length, 1);

      setPage('quiz');
    } catch (error) {
      console.error('Quiz data fetch failed:', error);
      alert('問題データの取得に失敗しました。');
    }
  };

  const handleSubmitAnswer = (selectedChoices) => {
    const currentQuestion = questions[currentQuestionIndex];
    const correctAnswers = currentQuestion.correct;
    const isAnswerCorrect = correctAnswers.every(answer => selectedChoices.includes(answer)) && 
                           selectedChoices.length === correctAnswers.length;

    if (!isAnswerCorrect) {
      const updatedWrongQuestions = [...wrongQuestions, currentQuestion];
      setWrongQuestions(updatedWrongQuestions);
      localStorage.setItem(STORAGE_KEYS.WRONG_QUESTIONS, JSON.stringify(updatedWrongQuestions));
    }

    setIsCorrect(isAnswerCorrect);
    setPage('results');
  };

  const handleNextQuestion = () => {
    const remainingQuestions = [...questions];
    remainingQuestions.splice(currentQuestionIndex, 1);

    if (remainingQuestions.length > 0) {
      const randomIndex = Math.floor(Math.random() * remainingQuestions.length);
      setQuestions(remainingQuestions);
      setCurrentQuestionIndex(randomIndex);
      setCurrentQuestionNum(prev => prev + 1);

      localStorage.setItem(STORAGE_KEYS.QUESTIONS, JSON.stringify(remainingQuestions));
      localStorage.setItem(STORAGE_KEYS.CURRENT_INDEX, randomIndex);
      localStorage.setItem(STORAGE_KEYS.CURRENT_NUM, currentQuestionNum + 1);

      setPage('quiz');
    } else {
      setPage('home');
    }
  };

  return {
    page,
    setPage,
    questions,
    currentQuestionIndex,
    questionLength,
    currentQuestionNum,
    isCorrect,
    wrongQuestions,
    setWrongQuestions,
    setQuestionLength,
    setQuestions,
    setCurrentQuestionIndex,
    setCurrentQuestionNum,
    handleStartQuiz,
    handleSubmitAnswer,
    handleNextQuestion,
  };
}; 
